/* =========================================================
   TAVERN CRAWL GAMES — Motion & Animation Trigger Script
   Paste this into a new snippet, e.g. snippets/custom-animations.liquid
   wrapped in <script> tags, OR add as an assets/custom-animations.js
   file and include in theme.liquid right before </body> with:
   <script src="{{ 'custom-animations.js' | asset_url }}" defer></script>
   ========================================================= */

document.addEventListener("DOMContentLoaded", function () {
  // 1. Auto-tag common Shopify sections/cards for scroll-reveal
  //    so you don't have to manually edit every .liquid file.
  //    Adjust selectors if your theme uses different class names.
  var autoTargets = document.querySelectorAll(
    ".shopify-section, .card-wrapper, .product-card, .grid__item"
  );
  autoTargets.forEach(function (el) {
    if (!el.classList.contains("reveal-on-scroll")) {
      el.classList.add("reveal-on-scroll");
    }
  });

  // 2. Tag the hero/banner section for the floating motion effect
  //    Update this selector to match your theme's actual hero section class
  var hero = document.querySelector(".banner, .hero, .slideshow__slide");
  if (hero) {
    hero.classList.add("hero-motion");
    var heroContent = hero.querySelector(".banner__content, .hero__content, .slideshow__text-wrapper");
    if (heroContent) {
      heroContent.classList.add("hero-motion__content");
    }
  }

  // 3. IntersectionObserver to reveal elements as they scroll into view
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target); // animate once, not every scroll
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -50px 0px" }
  );

  document.querySelectorAll(".reveal-on-scroll").forEach(function (el) {
    observer.observe(el);
  });
});